function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { FunctionalLoader } from 'seagull';
import { useStoreActions } from "../contexts";
import AgreementStudioTemplates from "./AgreementStudio/AgreementStudioTemplates";
import { makeSentryIgnoredError } from "./ErrorBoundaryPage";
export default function ProposalTemplateLoader(props) {
  const {
    api
  } = useStoreActions();
  const {
    templateId
  } = props.match.params;
  const [template, setTemplate] = useState({
    data: undefined,
    error: null
  });
  useEffect(() => {
    setTemplate({
      data: undefined,
      error: undefined
    });
    api.proposalTemplates.get(templateId).then(res => setTemplate({
      data: res,
      error: undefined
    }), err => setTemplate({
      data: undefined,
      error: err
    }));
  }, [templateId]);
  if (template.error) {
    throw makeSentryIgnoredError('Failed to fetch template');
  } else if (!template.data) {
    return /*#__PURE__*/React.createElement(FunctionalLoader, {
      name: "ProposalTemplateLoader",
      show: true
    });
  } else {
    return /*#__PURE__*/React.createElement(AgreementStudioTemplates, _extends({}, props, {
      template: template.data
    }));
  }
}